<template>
  <!-- 导航栏 -->
  <div class="bottom">
    <div class="navbar">
      <!-- <ul class="classify">
        <li class="back_primary"
            :class="checked? 'checked': ''"
            @mouseenter="isOpenCatergory(true)"
            @mouseleave="isOpenCatergory(false)">
          全部分类
          <div class="category_list"
               v-show="isShowList">
            <div class="goods_category">
              <div class="title_top">商品分类</div>
              <div class="wrap-content">
                <span v-for="(item,index) in goodsCategory"
                      :key="index">
                  <router-link :style="{'color':item.colour}"
                               :to="{path:'/category', query:{productCategoryIdI: item.parentId, productCategoryId: item.id}}"
                               target="_blank">{{item.name}}</router-link>
                  <router-link v-for="(pitem,pindex) in item.productCategoryDtoList"
                               :style="{'color':pitem.colour}"
                               :key="pindex"
                               :to="{path:'/category', query:{productCategoryIdI: item.parentId, productCategoryId: pitem.parentId,productCategoryIdIii: pitem.id}}"
                               target="_blank">{{pitem.name}}</router-link>
                </span>
              </div>
              <div class="search_history">
                <span v-for="(item,index) in vocabularyList"
                      :key="index">
                  <router-link :class="(searchName && searchName == item) || (!searchName && index === 0) ? 'primary': ''"
                               :to="{path: '/searchGoods', query: {key: item}}"
                               target="_blank">{{item}}
                  </router-link>
                </span>
              </div>
            </div>
            <div class="market_nav goods_category">
              <div class="title_top">市场导航</div>
              <div class="wrap-content">
                <router-link v-for="(item,index) in stallList"
                             :key="index"
                             :style="{'color':item.colour}"
                             :to="{path: 'market', query: {id: item.id}}"
                             target="_blank">{{item.name}}</router-link>
              </div>
            </div>
          </div>
        </li>
      </ul> -->
      <ul class="menu">
        <li class="no-bg">
          <router-link
            class="link"
            :to="{ name: 'index' }"
            :class="$route.name === 'index' ? 'primary' : ''"
            >首页
          </router-link>
        </li>
        <!-- 自定义栏目 -->
        <li v-for="(item, index) in customMenus" :key="index">
          <a
            v-if="item.link.indexOf('http') == 0"
            class="link"
            target="_self"
            :class="
              $route.fullPath === item.link.split('com')[1] ? 'primary' : ''
            "
            :href="item.link"
            >{{ item.columnName }}</a>
          <router-link
            v-else
            class="link"
            target="_self"
            :to="{ path: item.link }"
            :class="$route.name === item.link ? 'primary' : ''"
            >{{ item.columnName }}
          </router-link>
        </li>
      </ul>
      <div class="login">
        <div v-if="username">
          <Row type="flex" justify="end" align="middle">
            <Col
              ><img
                :src="common.showPic(usericon)"
                :onerror="common.defaultAvatar()"
            /></Col>
            <Col>
              <p>Hi，{{ username }}</p>
              <!-- <p>{{userInfo.levelName}}</p> -->
            </Col>
            <Col span="12">
              <Button
                class="login_btn"
                type="primary"
                :long="true"
                :to="{ name: 'userIndex' }"
                >个人中心</Button
              >
              <Button
                :to="{ name: 'browseRecord' }"
                type="primary"
                class="login_btn"
                ghost
                >历史记录</Button
              >
            </Col>
          </Row>
        </div>
        <div v-else>
          <Row type="flex" justify="end" align="middle">
            <!-- <Col><img src="@/assets/images/Headportrt.png" /></Col> -->
            <Col>
              <p>Hi，游客</p>
            </Col>
            <Col span="12">
              <Button to="/login" type="primary" class="login_btn"
                >登录
              </Button>
              <Button type="primary" class="login_btn" to="/register"
                >免费注册
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getHomeStallList,
  getMarketMenu,
  getAllShoesList,
  configData,
} from "@/api/index";
import { mapState } from "vuex";

export default {
  name: "BottomNav",
  data() {
    return {
      checked: false, // 商品类目样式
      isActive: 1,
      isShowList: false, // 是否展开一级菜单
      menuId: null, // 被选中的一级菜单id
      goodsCategory: [],
      secondList: [], // 类目子级表
      stallList: [], //档口市场列表
      categoryKeywords: [], //类目下的关键词
      navigationList: [],
      customMenus: [],
      vocabularyList: [],
      searchName: "",
    };
  },
  mounted() {
    // debugger
    if (this.$route.name === "index") {
      this.isShowList = true;
      this.checked = true;
    } else {
      this.isShowList = false;
      this.checked = false;
    }
    this.getAllShoesList();
    this.getHomeStallList();
    this.getActivities();
    this.getHotVocabularyList();
  },
  computed: {
    ...mapState(["username", "usericon"]),
  },
  methods: {
    // 关键词展示
    getHotVocabularyList() {
      configData({
        key: "X_searchKeywords",
        tips: "首页搜索显示的关键字",
      }).then((res) => {
        let list = res.data.name.split(" ");
        this.vocabularyList = list;
      });
    },
    // 获取自定义栏目
    getActivities() {
      getMarketMenu({ pageNum: 1, pageSize: 100, show: 0 }).then((res) => {
        this.customMenus = res.data.list;
      });
    },
    //获取所有鞋类分类
    getAllShoesList() {
      getAllShoesList().then((res) => {
        res.data.forEach((item) => {
          this.goodsCategory = item.productCategoryDtoList;
        });
      });
    },
    // 档口市场
    getHomeStallList() {
      getHomeStallList().then((res) => {
        this.stallList = res.data;
        // 数据中存在鞋都电商园就放第一个
        this.stallList.forEach((item, index) => {
          if (item.name === "鞋都电商园") {
            this.stallList.splice(index, 1);
            this.stallList.unshift(item);
          }
        });
      });
    },
    // 一级菜单的显示隐藏
    isOpenCatergory(value) {
      if (this.$route.name === "index") {
        // 首页时默认一直显示
        return;
      }
      this.isShowList = value;
    },
    // 监听路由
    watchPath() {
      if (this.$route.name === "index") {
        this.isActive = 1;
        this.isShowList = true;
        this.checked = true;
      } else if (this.$route.name === "good") {
        this.isActive = 2;
        this.isShowList = false;
        this.checked = false;
      } else {
        this.isActive = null;
        this.isShowList = false;
        this.checked = false;
      }
      this.menuId = null; // 解决更换路由下id
    },
  },
  watch: {
    $route: "watchPath",
  },
};
</script>

<style lang="less" scoped>
/*底部*/
.navbar {
  font-size: 14px;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding-top: 2px;
  padding-bottom: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 99;
}

.wrap-content {
  margin-top: 10px;
  font-size: 14px;
  a {
    color: #333;
    line-height: 2;
    margin-right: 8px;
  }
  a:hover {
    color: tomato;
  }
}

.menu {
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

.menu li {
  font-weight: bold;
  color: #ffffff;
  height: 30px;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  background-position: 0 -30px;
  background-image: url(https://g1.17qcc.com/2018/home/sprites.png?201909);
  background-repeat: no-repeat;
}

.menu li:first-child {
  background: none;
}

.menu .link {
  font-size: 14px;
  color: #020202;
  width: 100%;
  line-height: 30px;
}

.menu li:hover .link {
  color: #ff5500;
}

/*下拉菜单*/
.classify > li:first-child {
  font-size: 14px;
  width: 240px;
  height: 36px;
  color: #ffffff;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/*一级菜单*/
.category_list {
  width: 240px;
  height: 410px;
  color: #333;
  background: #fff;
  position: absolute;
  top: 38px;
  left: 0;
  z-index: 99;
  font-size: 13px;

  .flexRow {
    padding: 0 12px;
    height: 70px;
    justify-content: flex-start;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-bottom: 1px solid #eeeeee;
    background-color: white;

    .titles {
      text-align: left;
      p {
        &:first-child {
          color: #333;
          font-size: 14px;
          font-weight: 500;
          &:hover {
            color: #ff5500;
          }
        }
      }
    }

    img {
      width: 22px;
      margin-right: 10px;
    }
  }

  .flexRow.menuChecked {
    //一级菜单选中时
    border: 1px solid #ef6c00;
    border-right-color: white;
    position: relative;
    z-index: 999;
  }
}

/*二级菜单*/
.second_category {
  width: 964px;
  height: 561px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: -1px;
  left: 239px;
  z-index: 99;
  border: 1px solid #ef6c00;
  background-color: white;
}

.hot_market {
  width: 964px;
  height: 560px;
  background: #fff;
  padding: 16px;
  position: absolute;
  top: 0px;
  left: 239px;
  z-index: 99;
  border: 1px solid #ef6c00;
  background-color: white;

  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    span:first-child {
      font-size: 14px;
      color: #020202;
      font-weight: bold;
    }

    .more {
      font-size: 11px;
      color: #999999;
    }
  }

  .list {
    .shop {
      margin-bottom: 20px;

      .img img {
        height: 128px;
      }
    }

    p {
      font-size: 12px;
      color: #999;
    }

    .good_card {
      width: 32%;
      margin-right: 1.333%;
    }

    .good_info {
      padding: 6px;
    }
  }
}

.second_category .list_info {
  padding: 15px;
  width: 964px;
  text-align: left;
  overflow: auto;
}

.second_category .brands {
  padding: 15px;
  background: #f5f5f5;
  width: 220px;

  p {
    font-size: 14px;
    color: #020202;
    text-align: left;
    margin-bottom: 16px;
  }

  ul.brand_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      width: 48%;
      height: 64px;
      margin-bottom: 10px;
      background: #ffffff;
    }
  }
}

.list_info .keyword_group {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;

  button {
    color: #ffffff;
    margin-right: 20px;
    margin-bottom: 10px;
  }
}

.list_info .second_list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}

.list_info .second_list .second_cate {
  width: 100%;
  padding: 10px 0;
  text-align: left;
  display: flex;

  .second_title {
    width: 80px;
    color: #020202;
    font-weight: bold;
    text-align: right;
  }

  i {
    margin-left: 10px;
  }
}

.list_info .three_cate {
  display: flex;
  flex-wrap: wrap;
  flex: 1;

  li {
    padding: 0 5px;

    a {
      color: #666666;
      font-size: 11px;
    }

    a:hover {
      color: #ef6c00;
    }
  }
}

.goods_category {
  height: 50%;
  padding: 12px 12px 0;
  text-align: left;
  line-height: 20px;
  overflow-x: hidden;
  overflow-y: auto;

  .title_top {
    font-size: 18px;
    font-weight: 500;
  }

  .goods_info {
    display: flex;
    flex-direction: row;
    padding-top: 5px;
    white-space: nowrap;
    font-size: 14px;
  }
  .goods_right {
    display: flex;
    flex-direction: column;
    white-space: pre-wrap;
    width: 200px;

    p {
      white-space: nowrap;
    }
  }
}

.market_nav {
  padding-top: 12px;
}

.search_history {
  font-size: 14px;
  margin-top: 10px;
}

.search_history span {
  a {
    color: #666666;
    line-height: 2;
    margin-right: 8px;
  }
}
// 登录样式
.login {
  width: 25%;
  background: #fff;
  text-align: right;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

.login_btn {
  width: 60px;
  margin-left: 10px;
  font-size: 12px;
  padding: 0;
}

.login p {
  font-size: 12px;
  margin: 8px 5px;
}
</style>
